import { LoaderFnConfig } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

export const TimeFiltersWidgetLoader: LoaderFnConfig = {
    id: 'time-filters-widget',
    loaderFn: () => import('./time-filters-widget.feature'),
    product: ClientConfigProductName.SPORTS,
};
